/** Right-side panel: minimap of scenes — click a scene to jump cursor to its heading. */
export default function ScenesPanel({ scenes, onJump }) {
  return (
    <div data-testid="sp-scenes-panel">
      <h4 className="mb-3 font-serif text-base text-stone-900">Índice de escenas</h4>
      {scenes.length === 0 && (
        <p className="rounded-lg border border-dashed border-stone-300 p-4 text-center text-xs text-stone-500">
          Aún no hay escenas. Añade una cabecera de escena (INT./EXT. …) para empezar.
        </p>
      )}
      <ol className="space-y-1.5">
        {scenes.map((s) => (
          <li key={s.elementId}>
            <button
              onClick={() => onJump(s.elementId)}
              data-testid={`sp-scene-jump-${s.number}`}
              className="w-full rounded border border-stone-200 bg-white px-3 py-2 text-left transition hover:border-[#26775E] hover:bg-[#26775E]/5"
            >
              <p className="flex items-center gap-2">
                <span className="font-mono text-[10px] text-stone-400">{String(s.number).padStart(2, "0")}</span>
                <span className="truncate font-mono text-xs font-bold uppercase text-stone-900">
                  {s.heading || "Sin título"}
                </span>
              </p>
              {s.firstAction && (
                <p className="ml-7 mt-0.5 truncate text-[11px] italic text-stone-500">{s.firstAction}</p>
              )}
              {s.characters.length > 0 && (
                <p className="ml-7 mt-0.5 font-mono text-[10px] uppercase tracking-wider text-[#26775E]">
                  {s.characters.join(" · ")}
                </p>
              )}
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
}
